import React from "react"
import * as styles from "../styles/hero.module.scss"
import { GatsbyImage} from "gatsby-plugin-image"
import Rich from "./rich"

const hero = props => {
  return (
    <section className={`${styles.hero} ${props.home ? styles.home : ""}`}>
      {props.choice === "image" ? (
        <GatsbyImage image={props.imgSrc} alt={props.imgAlt} />
      ) : (
        <video autoPlay playsInline muted loop>
          <source src={props.src} />
          <p>
            Your browser doesn't support HTML video. Here is a{" "}
            <a href={props.src}>link to the video</a> instead.
          </p>
        </video>
      )}
      <div className={styles.overlay}>
        <div className="container">
          <h1>{props.title}</h1>
          {props.subtitle ? <h2>{props.subtitle}</h2> : ""}
          {props.links ? <Rich text={props.links} /> : ""}
        </div>
      </div>
    </section>
  )
}

export default hero
